import Joi from 'joi';


const schemaForEmail = Joi.object({
  email: Joi.string().email({ tlds: false }).required(),
});

/**
 *
 * @param {string} email
 * @returns {boolean}
 */
export const validateEmail = (email) => {
  const validationResult = !schemaForEmail.validate({ email }).error;
  return validationResult;
}
